import { ReactElement } from 'react';

import { assertUnreachable, FormContextValues, TranslatableText } from '@dreryk/react-common';

import { dischargeSummaryTranslationKeys } from '../../../../translations';

import { StyledReferringPhysicianGuidelinesTextareaField } from './ReferringPhysicianGuidelinesTextareaField.styled';

type ReferringPhysicianGuidelinesTextareaFieldName =
   | 'diagnosticsGuidelines'
   | 'pharmacotherapyGuidelines'
   | 'otherGuidelines';

const getLabelByFieldName = (fieldName: ReferringPhysicianGuidelinesTextareaFieldName): TranslatableText => {
   switch (fieldName) {
      case 'diagnosticsGuidelines':
         return dischargeSummaryTranslationKeys.inDiagnosticsScope;
      case 'pharmacotherapyGuidelines':
         return dischargeSummaryTranslationKeys.inPharmacotheraptyScope;
      case 'otherGuidelines':
         return dischargeSummaryTranslationKeys.other;
      default:
         return assertUnreachable(fieldName);
   }
};

const getPlaceholderByFieldName = (fieldName: ReferringPhysicianGuidelinesTextareaFieldName): TranslatableText => {
   switch (fieldName) {
      case 'diagnosticsGuidelines':
         return dischargeSummaryTranslationKeys.fillDiagnosticsScopeGuidelines;
      case 'pharmacotherapyGuidelines':
         return dischargeSummaryTranslationKeys.fillPharmacotherapyScopeGuidelines;
      case 'otherGuidelines':
         return dischargeSummaryTranslationKeys.fillOtherGuidelines;
      default:
         return assertUnreachable(fieldName);
   }
};

const REFERRING_PHYSICIAN_GUIDELINES_TEXTAREA_FIELD_MAX_LENGTH = 300;

type ReferringPhysicianGuidelinesTextareaFieldFormBeanPart = {
   [key in 'diagnosticsGuidelines' | 'pharmacotherapyGuidelines' | 'otherGuidelines']: string | null;
};

type ReferringPhysicianGuidelinesTextareaFieldProps = Pick<
   FormContextValues<ReferringPhysicianGuidelinesTextareaFieldFormBeanPart>,
   'register'
> & {
   readonly name: ReferringPhysicianGuidelinesTextareaFieldName;
};

export const ReferringPhysicianGuidelinesTextareaField = (
   props: ReferringPhysicianGuidelinesTextareaFieldProps
): ReactElement => {
   return (
      <StyledReferringPhysicianGuidelinesTextareaField
         testId={props.name}
         controller={props.register(props.name)}
         label={getLabelByFieldName(props.name)}
         placeholder={getPlaceholderByFieldName(props.name)}
         maxLength={REFERRING_PHYSICIAN_GUIDELINES_TEXTAREA_FIELD_MAX_LENGTH}
         fillParent
      />
   );
};
